import { currencyToCountry } from '@/helpers/currencyToCountryCode';

/**
 * País ISO 3166 de una moneda fiat, para armar una wallet que no tiene de
 * dónde copiar su `countryCode`. Una stablecoin, o una moneda fuera del mapa,
 * no tiene país: devuelve `''`, nunca el país de otra moneda.
 */
export function resolveCurrencyCountryCode(currencyCode: string): string {
  return (currencyToCountry as Record<string, string | undefined>)[currencyCode] ?? '';
}

/**
 * Resuelve el código de bandera del grupo de moneda. El catálogo del backend
 * NO trae la bandera: solo el código de moneda.
 *
 * La regla es la que ya usa `getRouteFlagCountryCode`
 * (`modules/transaction/utils/quoterCurrency.util.ts:47`): una moneda fiat
 * muestra la bandera de su país, y una **stablecoin no tiene país** — su
 * código de bandera es el propio código de moneda, que resuelve el asset
 * `flags/gc_country_flag_usdt.png`.
 *
 * La discriminación es "¿tiene país fiat en el mapa ISO 4217?" y no
 * `isStablecoinCurrency` a propósito. Ese predicado
 * (`shared/common/utils/rateDisplayPrecision.util.ts`) es configuración de
 * **precisión de tasas** y su set es `{USDT, USDC}`, mientras que el de los
 * íconos (`STABLECOIN_CURRENCY_ICON_MAP`) es `{USDT, USDC, PYUSD}`: los dos
 * sets ya discrepan, así que atar la bandera a uno haría que la moneda que
 * falta en ese set muestre la bandera equivocada. Preguntándole al mapa de
 * países, una stablecoin nueva funciona sola y una moneda fiat ausente
 * degrada a no mostrar bandera — nunca a mostrar la de otro país.
 *
 * `EUR` devuelve `UE` (no `EU`) porque es lo que guarda el mapa del repo: es
 * el alias legacy que este camino de banderas consume sin normalizar.
 */
export function resolveFlagCountryCode(currencyCode: string): string {
  return resolveCurrencyCountryCode(currencyCode) || currencyCode;
}
